export class Infos {
    constructor(form) {
        this.form = form;
        this.elements = form.querySelectorAll(".js-info");
    }
    addToFormData(formData) {
        this.elements.forEach((element) => {
            formData.append(element.name, element.value);
        });
    }
    validate() {
        return true;
    }
}
